import parse from 'html-react-parser';
import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import ConnUrls from '../Connections/ConnectURL';
import { MobiOrNotContext } from "../Contexts/MobiOrNot_Context";

import styles from './MenuItmesSection.module.css';

import 'swiper/css';  // Core styles
import 'swiper/css/navigation';  // Navigation module styles
import 'swiper/css/pagination';  // Pagination module styles
import PlusMinusSelect from '../ForAllComponents/PlusMinusSelect';
import { TheOrderContext } from '../Contexts/TheOrder_Context';
import PopUpClearComp from '../PopUps/PopUpClearComp';
import ProductOptionsSelect from '../ProductPage/ProductOptionsSelect';
import { ElectricalServicesOutlined } from '@mui/icons-material';

const MenuItmesSection = (props) => {
  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
  const { theOrder, setTheOrder, addToTheOrder, updateTheOrd } = useContext(TheOrderContext);
  const [timgs, setTimgs] = useState([]);
  const [sectionHeader, setSectionHeader] = useState({});
  const [thePopUp, setThePopUp] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    setSectionHeader(props.theSectionHeader);
    setTimgs(props.itemsOfSection);
  }, [props.theSectionHeader]);

  const goToProduct = (prodId) => {

    navigate(`/prods/${prodId}`);
  };

  const updateCountVal = (val, newItem) => {
    let itmIndex = timgs?.findIndex(item => item._id === newItem._id);
    if (itmIndex !== -1) {
      timgs[itmIndex].mount = val || 1; // עדכן את ה-mount ב-timgs ל-1 אם val הוא 0
      newItem = timgs[itmIndex]; // עדכן את ה-newItem עם הערכים החדשים

      setTimgs([...timgs]); // עדכן את הסטייט של timgs
    }

    let prodIsInOrder = theOrder.items.find(ord => ord._id === newItem._id);

    if (val === 0) {
      // אם val הוא 0, הסר את הפריט מההזמנה
      const updatedOrder = {
        ...theOrder,
        items: theOrder.items.filter(ord => ord._id !== newItem._id),
      };
      updateTheOrd(updatedOrder); // עדכן את ההזמנה בסטייט
      return;
    }

    if (!prodIsInOrder) {
      // הוספה להזמנה אם לא קיים
      if (newItem.prodOptions && newItem.prodOptions.length > 0) {
        popOptions(newItem);
      } else {
        addToTheOrder(newItem);
      }
    } else {
      // עדכן את הפריט בהזמנה
      const updatedOrder = { ...theOrder };
      const orderItemIndex = updatedOrder.items.findIndex(ord => ord._id === newItem._id);
      if (orderItemIndex !== -1) {
        updatedOrder.items[orderItemIndex].mount = val; // עדכון ה-mount בהזמנה
      }
      updateTheOrd(updatedOrder); // עדכון ההזמנה בסטייט
    }
  };

  const addThisItem = (item) => {
    let itmindx = timgs?.findIndex(itm => itm._id === item._id);

    if (itmindx !== -1) {
      timgs[itmindx].mount = item.mount || 1;
      setTimgs([...timgs]);
    }

    let prodIsInOrder = theOrder.items.find(ord => ord._id === item._id);

    if (!prodIsInOrder) {
      // If item is new, handle popOptions if necessary
      if (item.prodOptions && item.prodOptions.length > 0) {
        popOptions(item);
      } else {
        addToTheOrder(item);
      }
    } else {
      // If item exists, update it and handle popOptions only if necessary
      if (item.prodOptions && item.prodOptions.length > 0) {
        popOptions(item);
      } else {
        updateTheOrd({ ...theOrder, items: [...theOrder.items] });
      }
    }
  };

  const popOptions = (item) => {
    setThePopUp(
      <PopUpClearComp
        BtnTxt={"סגור"}
        title={""}
        noLineStart={true}
        btnFStyle={"fatInBtn"}
        closePop={() => setThePopUp()}
        parentCLose={() => setThePopUp()}
        theInsideComp={
          <ProductOptionsSelect
            saveIt={() => setThePopUp()}
            closePop={() => setThePopUp()}
            item={item}
            options={item.prodOptions}
          />
        }
      />
    );
  };





  return (
    <div className={styles.HPSection}>
      {timgs?.map((item, index) => {
        let prodIsInOrder = theOrder.items.find(ord => ord._id === item._id);

        item.mount = prodIsInOrder ? prodIsInOrder.mount : item.mount || 1;
        return (
          <div
            key={index}
            className={`${!mobiOrNot ? styles.HPSectionItm : styles.HPSectionItmMobi}
                 ${styles.animate__pulseOut} ${styles.animate__pulseToIN} animate__animated pointing`}
          >
            <div className={`${styles.HPSectionInBlock}`}>
              <div
                className={`${!mobiOrNot ? styles.prodImg : styles.prodImgMobi}`}
                onClick={() => goToProduct(item._id)}
              >
                <img src={item.prodImageUrl !== "" ? ConnUrls.servMediasUrl + item.prodImageUrl : ConnUrls.servMediasUrl + props.mnuItemMainImg}
                  alt={item.altTags || item.prodName || ""} />
              </div>
              <div className={`${styles.prodName} pointing`}>{item.prodName}</div>
              <div className={"centerthisdiv"}>
                <div className={`${styles.prodPrice} pointing`}><span className={"onRight"}>{item.prodPrice}</span><span className={"onRight"}>₪</span></div>
              </div>


              <div className={"fullRow "} style={{ minHeight: '30px' }}>
                <div className={"wrapinorderTxt"}>
                  <div className={"inOrderP bold big inorderText"}>
                    {prodIsInOrder && "נמצא בהזמנה"}
                  </div>
                </div>
              </div>

              <div
                className={`${styles.addToCart} pointing`}
                onClick={() => addThisItem(item)}
              >
                {!prodIsInOrder ? "הוספה לסל" : "עדכון ההזמנה"}
              </div>
            </div>
          </div>
        );
      })}
      {thePopUp}
    </div>
  );
};

export default MenuItmesSection;
